<template>
  <div class="card">
    <div class="card-header">
      <p class="card-header-title">Recent Terminals</p>
    </div>
    <div>
      <div class="recent-entities-empty" v-if="terminals && terminals.length <= 0">
        <b-message>
          You have not visited any terminals recently.
        </b-message>
      </div>
      <div class="panel" v-else>
        <div class="panel-block" v-for="(r, i) in terminals" :key="i">
          <span class="panel-icon">
            <font-awesome-icon :icon="['far', 'satellite-dish']" />
          </span>
          <router-link class="kpt-recent-link has-text-weight-semibold" :to="{ name: 'terminalOverview', params: { id: r.id } }">{{r.name}}</router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { orderBy } from 'lodash';
import { onMounted, computed } from 'vue';
import { useAppSettingsStore } from '../../../user/stores/appsettings-store';

const appSettingsStore = useAppSettingsStore();
const terminals = computed(() => orderBy(appSettingsStore.state.recentTerminals, ['ts'], ['name']));

onMounted(async () => {
  await appSettingsStore.dispatch('fetchRecentEntities');
})
</script>
